import { fetcher } from '@/utils/fetcher'
import useSwr from 'swr'
import { API_URL } from '@/utils/constants'

/** A null or empty id skips the request (SWR's null key). */
export default function useInscriptionOutpoint(inscription_id: string | null | undefined) {
	return useSwr(inscription_id ? `${API_URL}/inscription/${inscription_id}/outpoint` : null, fetcher)
}
